import { useParams } from 'react-router';

import { useGetAboutSchoolQuery, useGetMainPageQuery } from '@/api/endpoints/mainPages';
import { FetchDataWrapper } from '@/shared/components';

import { transformDateToCorrectFormat } from '../helpers';

import { MainAboutSchoolPageComponent } from './MainAboutSchoolPageComponent';

export const MainAboutSchoolPage = () => {
  const { id } = useParams();
  const {
    data: pageData,
    isLoading: isPageLoading,
    isError: isPageDataFetchError,
  } = useGetMainPageQuery({ id: Number(id) });
  const {
    data: aboutSchoolData,
    isLoading: isAboutSchoolLoading,
    isError: isAboutSchoolFetchError,
  } = useGetAboutSchoolQuery({ id: Number(id) });

  return (
    <FetchDataWrapper
      isLoading={isAboutSchoolLoading || isPageLoading}
      isError={isAboutSchoolFetchError || isPageDataFetchError}
    >
      {pageData && aboutSchoolData && (
        <MainAboutSchoolPageComponent
          aboutSchoolData={aboutSchoolData}
          pageName={transformDateToCorrectFormat(pageData.created_at)}
          pageId={pageData.id}
        />
      )}
    </FetchDataWrapper>
  );
};
